"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Sync_1 = require("@twii/core-ui-fabric/lib/component/Sync");
var ListingTile_1 = require("./ListingTile");
var ListingList_styles_1 = require("./ListingList.styles");
var ListingList_classNames_1 = require("./ListingList.classNames");
var defaultListingRenderer = function (listing, index, props) {
    return React.createElement(ListingTile_1.ListingTile, { key: listing.id, listing: listing, onClick: props.onSelectItem });
};
var ListingList = /** @class */ (function (_super) {
    __extends(ListingList, _super);
    function ListingList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onRenderListing = function (listing, index) {
            var r = _this.props.onRenderListing || defaultListingRenderer;
            return r(listing, index, _this.props);
        };
        return _this;
    }
    ListingList.prototype.render = function () {
        if (this.props.listings && this.props.listings.length > 0) {
            var classNames = ListingList_classNames_1.getClassNames(ListingList_styles_1.getStyles(undefined, this.props.styles), this.props.className, this.props.compact, this.props.wrapping);
            var items = this.props.listings.map(this._onRenderListing);
            return (React.createElement("div", { className: classNames.root }, items));
        }
        return this.props.onRenderEmpty ? this.props.onRenderEmpty() : null;
    };
    return ListingList;
}(React.Component));
exports.ListingList = ListingList;
var ListingListContainer = /** @class */ (function (_super) {
    __extends(ListingListContainer, _super);
    function ListingListContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onRenderDone = function () {
            return React.createElement(ListingList, { listings: _this.props.listings.itemsView, onSelectItem: _this.props.onSelectItem, onRenderListing: _this.props.onRenderListing, compact: _this.props.compact, wrapping: _this.props.wrapping });
        };
        return _this;
    }
    ListingListContainer.prototype.componentWillMount = function () {
        this.props.listings.load();
    };
    ListingListContainer.prototype.render = function () {
        return React.createElement(Sync_1.Sync, { sync: this.props.listings.sync, onRenderDone: this._onRenderDone, syncLabel: "Loading Listings..." });
    };
    return ListingListContainer;
}(React.Component));
exports.ListingListContainer = ListingListContainer;
